module.exports = __webpack_public_path__ + "img/DSC_1872.ddb352af.JPG";